import React, { useEffect, useState } from 'react';
import { ImageOffIcon } from 'lucide-react';
import { BOEHRINGER_REPORT_PDF, PDF_PAGE_ASPECT } from '../data/boehringerSnak';
import { getPdfCrop } from '../utils/pdfRender';
import type { PdfCrop } from '../types/pdfCrop';
interface PdfImageProps {
  crop: PdfCrop;
  alt: string;
  className?: string;
  src?: string;
}
type LoadState = {
  status: 'loading';
} | {
  status: 'ready';
  dataUrl: string;
} | {
  status: 'error';
};

/** Displays a region of the Boehringer report PDF as an image. */
export function PdfImage({
  crop,
  alt,
  className = '',
  src = BOEHRINGER_REPORT_PDF
}: PdfImageProps) {
  const [state, setState] = useState<LoadState>({
    status: 'loading'
  });
  useEffect(() => {
    let active = true;
    setState({
      status: 'loading'
    });
    getPdfCrop(src, crop).then(dataUrl => active && setState({
      status: 'ready',
      dataUrl
    })).catch(() => active && setState({
      status: 'error'
    }));
    return () => {
      active = false;
    };
  }, [src, crop.page, crop.x, crop.y, crop.w, crop.h]);
  if (state.status === 'ready') {
    return <img src={state.dataUrl} alt={alt} className={className} data-id="element-195" data-mp="eihm652vaxsb" />;
  }
  const aspectRatio = crop.w / crop.h * PDF_PAGE_ASPECT;
  return <div role="img" aria-label={alt} aria-busy={state.status === 'loading'} className={`${className} flex items-center justify-center bg-[var(--surface)] ${state.status === 'loading' ? 'animate-pulse' : ''}`} style={{
    aspectRatio,
    width: '100%',
    maxHeight: '100%'
  }} data-id="element-196" data-mp="t7xbrhqnwx6f">
      {state.status === 'error' && <ImageOffIcon className="h-5 w-5 text-[var(--muted)]" aria-hidden="true" data-id="element-197" data-mp="1c5q2zmrxbinz" />}
    </div>;
}